module.exports = __webpack_public_path__ + "static/media/collection-bird-07-effect.a03706ba.png";